export const MB = 1024 ** 2;
export const GB = 1024 ** 3;
export const SYSTEM_MAX_BYTES = GB; // 1 GiB = 1073741824

export type FileSizeUnit = 'MB' | 'GB';

export const toBytes = (value: number, unit: FileSizeUnit): number => {
  const multiplier = unit === 'GB' ? GB : MB;
  const bytes = Math.round(value * multiplier);
  return Math.min(Math.max(bytes, 0), SYSTEM_MAX_BYTES);
};

export const formatLimit = (bytes: number): string =>
  bytes % GB === 0 ? `${bytes / GB} GB` : `${Math.round(bytes / MB)} MB`;

export const formatFileSize = (bytes: number): string =>
  bytes >= 1000 * MB
    ? `${(bytes / GB).toFixed(1)} GB`
    : `${Math.round(bytes / MB)} MB`;
